import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { CommonMethod } from 'src/app-core/methods/common-methods';
import { CommonService } from 'src/app-core/services/common.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { CommonDataModel } from '../common-data-model';

@Component({
    selector: 'app-freight-shopper-carrier-list',
    templateUrl: './freight-shopper-carrier-list.component.html',
    styleUrls: ['./freight-shopper-carrier-list.component.scss']
})
export class FreightShopperCarrierListComponent extends AppComponentBase implements OnInit {

    @ViewChild('grid', { static: true }) private grid: GridComponent;
    @ViewChild(TooltipDirective, { static: true }) public tooltipDir: TooltipDirective;
    @Input() isPreview: boolean;
    @Input() set carrierCostList(carrierCostList: any) {
        if (carrierCostList) {
            carrierCostList.data.forEach(item => {
                item.outerLength = this.formatDimensions(item.outerLength);
                item.outerWidth = this.formatDimensions(item.outerWidth);
                item.outerHeight = this.formatDimensions(item.outerHeight);
                item.unitWeight = this.formatDimensions(item.unitWeight);
                item.extWeight = this.formatDimensions(item.extWeight);
            });
            this.gridItems = carrierCostList;
            this.onCalculateTotal();
        }
    }    
    commonDataModel = new CommonDataModel();
    totals = this.commonDataModel.carrierCostsTotalsModel;
    gridItems: any = {
        data: [],
        total: 0
    };
    classList = this.commonDataModel.getCommonCarrierClass;
    pkgList: any;
    editedRowIndex: number;

    constructor(
        injector: Injector,
        private commonMethod: CommonMethod,
        private commonService: CommonService) {
        super(injector);
    }

    ngOnInit() {
        this.onLoadPackageTypes();
        this.expandRows();
    }

    onLoadPackageTypes() {
        this.commonService.getPackageType().subscribe(response => {
            if (response.isSuccess) {
                this.pkgList = response.data;
            }
        });
    }

    onCellClickHandler({ sender, rowIndex }, grid: any) {
        grid.closeRow(this.editedRowIndex);
        this.editedRowIndex = rowIndex;
        sender.editRow(rowIndex);
    }

    expandRows() {
        this.commonMethod.expandRows(this.grid);
    }

    formatDimensions(value: number): number {
        return this.commonMethod.convertDecimalToNextWholeNumber(value);
    }

    onCalculateTotal() {
        if (this.gridItems) {
            this.gridItems.data.map((item, index) => {
                this.totals.totalQuantity += item.quantity;
                this.totals.unitWeightOverallTotal += item.unitWeight;
                this.totals.extWeightOverallTotal += item.extWeight;
                this.totals.lbsByCuFeOverallTotal += item.lbsByCubicFeet;
            });
        }
    }

    calculateVolume(dataItem): number {
        return (this.formatDimensions(dataItem.outerLength) * this.formatDimensions(dataItem.outerWidth) * this.formatDimensions(dataItem.outerHeight) * this.formatDimensions(dataItem.quantity)) / 1728;
    }

    calculateTotalWeight(dataItem): number {
        const volume = this.calculateVolume(dataItem);
        return (this.formatDimensions(dataItem.extWeight)) / volume;
    }

    getFreightClass(density: number): string {
        return this.commonMethod.getFreightClass(density)
    }

    onShowTooltip(e: any): void {
        if (e.target.offsetWidth < e.target.scrollWidth) {
            this.tooltipDir.toggle({ nativeElement: e.target });
        } else {
            this.tooltipDir.hide();
        }
    }

}
